module.exports = __webpack_public_path__ + "images/background-blue-1-01f16d7d4984475c5c50a2777299b5f6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/background-blue-1.svg
// module id = 8
// module chunks = 0